<template>
  <div class="password-container">
    <input
      aria-label="password"
      class="password-field"
      type="password"
      placeholder="Please Input Your Password"
      v-model="password"
    />
    <p class="wrong-password" v-if="passwordIncorrect">Wrong password. Try again.</p>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

import FacilitatorService from '@/services/facilitator';

const emit = defineEmits(['confirmed', 'update:modelValue']);
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const password = ref(null);
const passwordIncorrect = ref(false);

async function confirmPassword() {
  const payload = { password: password.value || '' };
  const passwordResult = await FacilitatorService.verifyPassword(payload);

  if (passwordResult.success) {
    emit('confirmed');
  } else {
    passwordIncorrect.value = true;
    emit('update:modelValue', false);
  }
}

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      confirmPassword();
    }
  }
);
</script>

<style scoped>
.password-container {
  position: relative;
  width: 100%;
  height: 4.5em;

  margin-bottom: 2.3em;
}
.password-field {
  font-size: 16px;
  width: calc(100% - 1em);
  height: 2.6em;
  padding-left: 1em;
  border: 1px solid #a7a9ac;
  border-radius: 5px;
}
.password-field::placeholder {
  font-style: italic;
}
.wrong-password {
  position: absolute;
  bottom: 0%;
  width: 100%;
  margin: 0;

  font-style: italic;
  color: #df0d0d;
}
</style>
